import clsx from "clsx"
export default function Pause({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-9 h-auto')} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#38362D"/>
      <rect x="13" y="11.5" width="3" height="13" fill="#F5F0E3"/>
      <rect x="20" y="11.5" width="3" height="13" fill="#F5F0E3"/>
    </svg>
  )
}
